import ReactGA from 'react-ga4'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import TagManager from 'react-gtm-module'
import { Home } from './pages'
import { Pager } from './pages'
import { HomeAviso } from './pages'

const TRACKING_ID = 'G-6023EXQ19W'
const tagManagerArgs = { gtmId: 'GTM-5LXG3JR' }

ReactGA.initialize(TRACKING_ID)
TagManager.initialize(tagManagerArgs)

const App = () => {
	return (
		<BrowserRouter>
			<Routes>
				<Route index element={<Home />} />
				<Route path="beneficios-soymas" element={<Pager />} />
				<Route path="aviso-de-privacidad" element={<HomeAviso />} />
				
			</Routes>
		</BrowserRouter>
	)
}

export default App